'use strict';

import 'datatables.net/js/jquery.dataTables.min';
import 'datatables.net-bs/js/dataTables.bootstrap.min';
import 'datatables.net-bs/css/dataTables.bootstrap.min.css';
//import 'datatables.net-dt/css/jquery.dataTables.css';

import dt from 'angular-datatables';

import 'angular-datatables/dist/plugins/buttons/angular-datatables.buttons';
import 'angular-datatables/dist/plugins/bootstrap/datatables.bootstrap.min.css';

//import 'datatables.net-responsive/js/dataTables.responsive.min';
//import 'datatables.net-responsive-dt/css/responsive.dataTables.css';
import 'datatables.net-responsive-bs/js/responsive.bootstrap.min';
import 'datatables.net-responsive-bs/css/responsive.bootstrap.min.css'

//import 'datatables.net-buttons';
/*
import 'datatables.net-buttons/js/dataTables.buttons.min';
import 'datatables.net-buttons/js/buttons.colVis.min';
import 'datatables.net-buttons/js/buttons.html5.min';
import 'datatables.net-buttons/js/buttons.print.min';
*/
import 'datatables.net-buttons-bs/js/buttons.bootstrap.min';
import 'datatables.net-buttons/js/buttons.colVis.min';
import 'datatables.net-buttons/js/buttons.html5.min';
import 'datatables.net-buttons/js/buttons.print.min';

import 'angular-datatables/dist/plugins/bootstrap/angular-datatables.bootstrap.min';
//import 'angular-datatables/dist/plugins/bootstrap/datatables.bootstrap.min.css';

import 'datatables.net-buttons-bs/css/buttons.bootstrap.min.css';

import DataTableComponent from '../../components/datatable/datatable.component';

/* Module */
export default angular.module('conduu.ap.datatables', [dt, 'datatables.bootstrap', DataTableComponent, ])
  .name;



// WEBPACK FOOTER //
// ./client/~ap/app/datatables/index.js